import { addMonths } from 'date-fns'
import { PERSIST_QUERY } from '~/constants'
import { roleKey, tokenKey } from '~/constants/auth'
import useAuthStore from '~/store/auth'
import type { User } from '~/types/auth'

const useSuccessfulLogin = () => {
  const { push } = useRouter()
  const route = useRoute()
  const { checkVersion } = useVersionCheck()
  const authStore = useAuthStore()
  const { setIsAuth, setRole } = authStore
  const { catchErrors } = useErrorHandler()

  const { refetch: refetchCurrentUser } = useCurrentUser(false)

  const login = async ({ token, remember, user }: { token: string; remember: boolean; user: User }) => {
    try {
      const cookieOptions = {
        expires: remember ? addMonths(new Date(), 1) : undefined,
      }

      const tokenCookie = useStatefulCookie(tokenKey, cookieOptions)
      const roleCookie = useStatefulCookie(roleKey, cookieOptions)

      tokenCookie.value = token
      roleCookie.value = user.role.code

      // We are using nextTick here because cookies (token) are not updated immediately.
      await nextTick()

      setIsAuth(true)
      setRole(user.role.code)

      await checkVersion()

      await refetchCurrentUser()

      await push({
        name: 'dashboard',
        ...(route.query[PERSIST_QUERY.BCLICKID]
          ? { query: { [PERSIST_QUERY.BCLICKID]: route.query[PERSIST_QUERY.BCLICKID], tracked: 'true' } }
          : {}),
      })
    } catch (error) {
      catchErrors(error)
    }
  }

  return {
    login,
  }
}

export default useSuccessfulLogin
